import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { CREATE_SERIES, LINK_SOCIAL_ACCOUNTS, SERIES, SIGN_IN } from '../route';
import {
  ChevronDown,
  ChevronRight,
  DollarSign,
  Home,
  Link2,
  LogOut,
  Video,
  Menu,
  X,
} from 'lucide-react';

const SideBar = () => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem('authToken');
    navigate(SIGN_IN);
  };

  const menuItems = [
    { name: 'Home', icon: Home, path: '/' },
    {
      name: 'Series',
      icon: Video,
      path: SERIES,
      subItems: [
        { name: 'My Series', path: SERIES },
        { name: 'Create New Series', path: CREATE_SERIES },
      ],
    },
    { name: 'Upgrade Plan', icon: DollarSign, path: '/upgrade-plan' },
    { name: 'Link Accounts', icon: Link2, path: LINK_SOCIAL_ACCOUNTS },
  ];

  const handleMenuClick = (item) => {
    if (item.subItems) {
      setExpandedMenus((prev) => ({ ...prev, [item.name]: !prev[item.name] }));
    } else {
      setExpandedMenus({});
      setIsMobileMenuOpen(false);
    }
  };

  const SidebarContent = () => (
    <>
      <div className='flex items-center justify-center h-16 border-b border-gray-200 px-4'>
        <svg
          className='w-10 h-10 text-indigo-600'
          fill='currentColor'
          viewBox='0 0 20 20'
        >
          <path d='M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z'></path>
        </svg>
        <span className='ml-2 text-xl font-semibold text-gray-800'>
          FastShorts
        </span>
      </div>
      <nav className='mt-6'>
        {menuItems.map((item) => (
          <div key={item.name}>
            <Link
              to={item.path}
              className={`flex items-center justify-between px-6 py-3 text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition duration-200 ${
                location.pathname === item.path ||
                (item.subItems &&
                  item.subItems.some(
                    (subItem) => location.pathname === subItem.path
                  ))
                  ? 'bg-indigo-50 text-indigo-600'
                  : ''
              }`}
              onClick={(e) => {
                if (item.subItems) {
                  e.preventDefault();
                }
                handleMenuClick(item);
              }}
            >
              <div className='flex items-center'>
                <item.icon className='h-5 w-5 mr-3' />
                {item.name}
              </div>
              {item.subItems &&
                (expandedMenus[item.name] ? (
                  <ChevronDown className='h-4 w-4' />
                ) : (
                  <ChevronRight className='h-4 w-4' />
                ))}
            </Link>
            {item.subItems && expandedMenus[item.name] && (
              <div className='bg-gray-50'>
                {item.subItems.map((subItem) => (
                  <Link
                    key={subItem.name}
                    to={subItem.path}
                    className={`block px-6 py-2 ml-6 text-sm text-gray-600 hover:text-indigo-600 transition duration-200 ${
                      location.pathname === subItem.path
                        ? 'text-indigo-600'
                        : ''
                    }`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {subItem.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
      <div className='absolute bottom-0 w-full border-t border-gray-200'>
        <button
          onClick={handleLogout}
          className='flex items-center w-full px-6 py-3 text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition duration-200'
        >
          <LogOut className='h-5 w-5 mr-3' />
          Logout
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* Mobile Menu Button */}
      <div className='lg:hidden fixed top-4 left-4 z-50'>
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className='p-2 rounded-md bg-white shadow-md'
        >
          {isMobileMenuOpen ? (
            <X className='h-6 w-6 text-gray-600' />
          ) : (
            <Menu className='h-6 w-6 text-gray-600' />
          )}
        </button>
      </div>

      {/* Desktop Sidebar */}
      <div className='hidden lg:block lg:w-64 bg-white shadow-lg h-screen'>
        <SidebarContent />
      </div>

      {/* Mobile Sidebar */}
      {isMobileMenuOpen && (
        <div className='lg:hidden fixed inset-0 z-40'>
          <div
            className='fixed inset-0 bg-black bg-opacity-50'
            onClick={() => setIsMobileMenuOpen(false)}
          />
          <div className='fixed inset-y-0 left-0 w-64 bg-white shadow-lg overflow-y-auto'>
            <SidebarContent />
          </div>
        </div>
      )}
    </>
  );
};

export default SideBar;
